export const DAY_CLOSES_AT_MAX_HOUR = 8;
export const MINUTES_PER_DAY = 1440;
const dateFormatters = new Map();
function dateFormatter(timeZone) {
    let cached = dateFormatters.get(timeZone);
    if (!cached) {
        cached = new Intl.DateTimeFormat('en-US', { timeZone, year: 'numeric', month: '2-digit', day: '2-digit' });
        dateFormatters.set(timeZone, cached);
    }
    return cached;
}
export function localDateOf(instant, timeZone) {
    const parts = dateFormatter(timeZone).formatToParts(instant);
    const value = (type) => parts.find((part) => part.type === type)?.value ?? '00';
    return `${value('year').padStart(4, '0')}-${value('month')}-${value('day')}`;
}
export function serviceDayOf(instant, timeZone, dayClosesAt) {
    return localDateOf(new Date(instant.getTime() - clampClosesAt(dayClosesAt) * 3_600_000), timeZone);
}
export function clampClosesAt(hour) {
    if (!Number.isFinite(hour))
        return 0;
    return Math.min(DAY_CLOSES_AT_MAX_HOUR, Math.max(0, Math.trunc(hour)));
}
export function addCalendarDays(date, days) {
    const [year, month, day] = date.split('-').map(Number);
    return new Date(Date.UTC(year, month - 1, day + days)).toISOString().slice(0, 10);
}
export function calendarDaysBetween(from, to) {
    const [fy, fm, fd] = from.split('-').map(Number);
    const [ty, tm, td] = to.split('-').map(Number);
    return Math.round((Date.UTC(ty, tm - 1, td) - Date.UTC(fy, fm - 1, fd)) / 86_400_000);
}
export function serviceDayWindow(day, dayClosesAt) {
    const minute = clampClosesAt(dayClosesAt) * 60;
    return { startDate: day, startMinute: minute, endDate: addCalendarDays(day, 1), endMinute: minute };
}
function hhmmMinutes(hhmm) {
    const [hour, minute] = hhmm.split(':').map(Number);
    return hour * 60 + minute;
}
export function sessionEndsNextDay(startTime, endTime) {
    return hhmmMinutes(endTime) <= hhmmMinutes(startTime);
}
export function sessionMinutes(startTime, endTime) {
    const start = hhmmMinutes(startTime);
    const end = hhmmMinutes(endTime);
    return { start, end: end <= start ? end + MINUTES_PER_DAY : end };
}
export function afterMidnightAllowed(startTime, endTime, dayClosesAt) {
    if (!sessionEndsNextDay(startTime, endTime))
        return true;
    return hhmmMinutes(endTime) <= clampClosesAt(dayClosesAt) * 60 && hhmmMinutes(endTime) < hhmmMinutes(startTime);
}
//# sourceMappingURL=clinic-day.js.map